// Reads the CSRF cookie issued by ztc-core's CsrfCookieFilter
// (SecurityConfig.kt). The cookie is set on any authenticated GET — typically
// the SPA's /api/me ping — and refreshed on subsequent requests. Callers use
// getCsrfHeader() to inject X-XSRF-TOKEN on mutations.
//
// Names are tried in PREFERENCE order, not document.cookie order: after the
// __Host- rename deploy, browsers still hold the stale pre-rename XSRF-TOKEN
// (the rename logs users out without running the logout handler that deletes
// it), and RFC 6265 serializes the older cookie first. Taking the first
// name-match would submit the stale token and 403 every mutation.

const COOKIE_NAMES = ["__Host-XSRF-TOKEN", "XSRF-TOKEN"];
const HEADER_NAME = "X-XSRF-TOKEN";

export const readCsrfCookie = (): string | null => {
  if (typeof document === "undefined") return null;
  const found = new Map<string, string>();
  for (const pair of document.cookie.split(";")) {
    const idx = pair.indexOf("=");
    if (idx < 0) continue;
    const name = pair.slice(0, idx).trim();
    if (!COOKIE_NAMES.includes(name) || found.has(name)) continue;
    found.set(name, pair.slice(idx + 1).trim());
  }
  for (const name of COOKIE_NAMES) {
    const value = found.get(name);
    if (value === undefined) continue;
    try {
      return decodeURIComponent(value);
    } catch {
      return value;
    }
  }
  return null;
};

export const getCsrfHeader = (): Record<string, string> => {
  const token = readCsrfCookie();
  return token ? { [HEADER_NAME]: token } : {};
};
